import React from "react";
import "./FinalApproverForService.scss"
import { FinalApproverServiceContextProvider } from "../../features/FinalApproverServieForm/FinalApproverServiceConext";
import FinalApproverServiceForm from "../../features/FinalApproverServieForm/FinalApproverServiceForm";

const FinalApproverForService = () => {
  return (
    <div className="page-container">
      <FinalApproverServiceContextProvider>
        <FinalApproverServiceForm />
      </FinalApproverServiceContextProvider>
    </div >

  );
};
export default FinalApproverForService;
